import { useContext } from 'react';

import { StepApiContext } from '../Context';

const useStepApi = () => {
  const api = useContext(StepApiContext);
  return api;
};

export default useStepApi;
